module.exports = __webpack_public_path__ + "media/images/flags/4x3/hnd-cba64dd3f1701077d3bc91b84ceac4ee.svg";